import httpClient from './httpClient'

const END_POINT = '/pois?limit=true'

const getPois = () => httpClient.get(END_POINT)

export { getPois }
